import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Loading, PageSubTitle } from 'components/common/Elements/Elements';
import SatisfactionItems from './SatisfactionItems/SatisfactionItems';
import BaseItem from './SatisfactionItems/BaseItem/BaseItem';

import { postRequest } from 'utils/requests';

const Satisfaction = ({ customerId }) => {
  const [satisfactionData, setSatisfactionData] = useState({});
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    let cancelled = false;
    postRequest('/customer/satisfaction', {
      customerId: customerId
    })
      .then(res => {
        if (!cancelled) {
          setSatisfactionData(res.body);
          setLoader(false);
        }
      })
      .catch(err => {
        if (!cancelled) {
          console.log(err);
          setLoader(false);
        }
      });
    return () => (cancelled = true);
  }, [customerId]);

  const healthSmile = health => {
    switch (health) {
      case 'Champion':
        return 'champion';
      case 'Healthy':
        return 'smile';
      case 'Need Attention':
        return 'needAttention';
      case 'At Risk':
        return 'sad';
      default:
        return 'smile';
    }
  };

  const healthData = {
    name: 'Health Score',
    value: satisfactionData.healthScore
      ? satisfactionData.healthScore.healthPoint
      : 0,
    additional: satisfactionData.healthScore
      ? satisfactionData.healthScore.healthStatus
      : null
  };

  const config = [
    {
      icon: satisfactionData.healthScore
        ? healthSmile(satisfactionData.healthScore.healthStatus)
        : 'smile',
      url: 'health-score',
      content: <BaseItem data={healthData} />,
      disabled: !(
        satisfactionData.healthScore && satisfactionData.healthScore.healthPoint
      )
    },
    {
      icon: 'nps',
      url: 'nps',
      content: <BaseItem data={{ name: 'NPS', value: satisfactionData.nps }} />,
      disabled: !satisfactionData.nps
    },
    {
      icon: 'openTickets',
      url: 'open-tickets',
      content: (
        <BaseItem
          data={{ name: 'Tickets', value: satisfactionData.openTickets }}
        />
      ),
      disabled: !satisfactionData.openTickets
    },
    {
      icon: 'won',
      url: 'csat',
      content: (
        <BaseItem
          data={{
            name: 'CSAT',
            tickets: satisfactionData.csat ? satisfactionData.csat.tickets : 0,
            chats: satisfactionData.csat ? satisfactionData.csat.chat : 0
          }}
        />
      ),
      disabled: !(
        satisfactionData.csat &&
        (satisfactionData.csat.chat || satisfactionData.csat.tickets)
      )
    },
    {
      icon: 'qbr',
      url: 'qbr',
      content: <BaseItem data={{ name: 'QBR', value: satisfactionData.qbr }} />,
      disabled: !satisfactionData.qbr
    },
    {
      icon: 'wonder',
      url: 'sentiment',
      content: (
        <BaseItem
          data={{ name: 'Sentiment', value: satisfactionData.sentiment }}
        />
      ),
      disabled: !satisfactionData.sentiment
    }
  ];

  if (loader) {
    return <Loading />;
  }

  return (
    <>
      <PageSubTitle hiden title="Satisfaction page" />
      <SatisfactionItems items={config} />
    </>
  );
};

Satisfaction.propTypes = {
  customerId: PropTypes.string
};

export default Satisfaction;
